<template>
  <div>
    <v-content>
      <section>
        <v-parallax src="assets/hero.jpeg" height="250">
          <v-layout column align-center justify-center class="white--text">
            <h1 class="white--text mb-2 display-1 text-center">Your warranties</h1>
            <div class="subheading mb-4 text-center">No worries, we'll send you and email!</div>

            <v-btn @click="showForm" class="mt-12" color="blue lighten-2" dark large>Add new one</v-btn>
          </v-layout>
        </v-parallax>
      </section>

      <section>
        <v-container>
          <v-row class="d-flex justify-center">
            <v-col cols="12" xs="8" sm="8" md="6">
              <v-text-field
                class="my-4"
                v-show="showSearch"
                solo-inverted1
                flat
                hide-details
                clearable
                @click:clear="resetSearch"
                label="Searching for a warranty ?"
                v-model="searchTerm"
                @keyup.enter="search"
              />
            </v-col>
          </v-row>
        </v-container>
      </section>
      <section v-if="noData">
        <v-layout column wrap class="my-12" align-center>
          <v-flex xs12>
            <v-container grid-list-x>
              <v-layout row wrap align-center class="d-flex justify-center">
                <p
                  v-show="!isLoading"
                  class="display-1 text--primary text-truncate"
                >Nothing found yet :(</p>
                <p
                  v-show="isLoading"
                  class="display-1 text--primary text-truncate"
                >Loading, please wait ....</p>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>
      <section>
        <v-layout column wrap class="my-12" align-center>
          <v-flex xs12>
            <v-container grid-list-x>
              <v-layout row wrap align-center class="d-flex justify-center">
                <v-flex v-for="item in warranties" :key="item.id">
                  <!-- todod add the item -->
                  <!-- <warranty :item="item" /> -->

                  <v-card
                    
                    max-width="250"
                    flat
                    class="mr-5 mb-5 d-inline-block mx-auto"
                    outlined
                  >
                    <v-card-text>
                      <!-- <div>Word of the Day</div> -->

                      <p class="display-1 text--primary text-truncate">{{item.product}}</p>
                      <p>{{item.seller}}</p>

                      <div class="text--primary">Bought on: {{item.buyDate | formatDate}}</div>
                      <div class="text--primary">Warranty: {{item.warrantyMonths}} months</div>
                      <div class="text--primary">Expiration: {{item.expirationDate | formatDate}}</div>
                    </v-card-text>
                    <v-card-actions>
                      <v-badge bordered color="error" icon="mdi-lock" message="AAAA" overlaph>
                        <v-btn text small color="primary" @click="showForm(item.id)">Details</v-btn>
                      </v-badge>
                    </v-card-actions>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>

      <section>
        <v-parallax src="assets/section.jpg" height="380">
          <v-layout column align-center justify-center>
            <div
              class="headline white--text mb-4 text-center"
            >Keeping track of your warranties has never been easier</div>
            <!-- <em>Kick-start your application today</em> -->
            <v-btn class="mt-12" color="blue lighten-2" dark large href="/">Log Out</v-btn>
          </v-layout>
        </v-parallax>
      </section>
    </v-content>

    <warranty-form :showForm="showDialog" :id="selectedId" @closeForm="closeForm"></warranty-form>
  </div>
</template>


<script>
import WarrantyForm from "./WarrantyForm";
import Warranty from "./Warranty";
import Vue from "vue";

let apiUrl = process.env.VUE_APP_API_URL;
apiUrl = "http://localhost:5000";

export default {
  components: {
    "warranty-form": WarrantyForm,
    warranty: Warranty
  },
  computed: {
    noData() {
      return (this.warranties || []).length == 0;
    }
  },
  methods: {
    closeForm() {
      this.loadData();
      this.showDialog = false;
      this.selectedId = null;

      console.log("closing the form");
    },
    showForm() {
      this.showForm(0);
    },
    showForm(id) {
      console.log("Opening for: ", id);
      if (id > 0) this.selectedId = id;
      else this.selectedId = 0;
      this.showDialog = true;
      console.log("display the FORM");
    },
    async loadData() {
      let query = "/api/warranties";
      if ((this.searchTerm || "").length > 0) query += `?q=${this.searchTerm}`;
      this.isLoading = true;
      const resp = await Vue.axios.get(`${apiUrl}${query}`);
      this.isLoading = false;
      this.warranties = resp.data;
    },
    search() {
      this.loadData();
    },
    resetSearch() {
      this.searchTerm = null;
      this.search();
    }
  },
  data() {
    return {
      isLoading: false,
      selectedId: null,
      searchTerm: "",
      showDialog: false,
      showSearch: true,
      items: [{ title: "Preferences" }, { title: "Log out" }],
      modal: false,
      warranties: []
    };
  },
  created() {
    console.log("created called");
    this.loadData();
  }
};
</script>
